export type CodeLanguage = "json" | "yaml" | "code" | "python" | "javascript" | "typescript"

export const DEFAULT_CODE_LANGUAGE: CodeLanguage = "json"
